module.exports = __webpack_public_path__ + "img/mockup2x.1665912d.webp";